import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import numeral from 'numeral';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import AddVideoIcon from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import { getSrcSet } from '../../Dumbo/Image/_helpers';
import ZoomModal from '../../ZoomModal';
import { scaleToSize } from '../../_helpers';
import { useFullview } from '../hooks/useFullview';
import { useImgIsLoading } from '../hooks/useImageIsLoading';
import s from './Image.scss';
export const Image = ({ source, altText = '', width, height, dontExpandWrapper, wrapperProps = {}, imageProps = {}, allowFullviewSrcsetForPngs = false, afterImage, className, withoutZoomModal, isZoomed, onEnterZoomMode, onExitZoomMode })=>{
    var _imgRef_current;
    // TODO: this is a hack and the Better Way would be to: break up this component
    const withZoomModal = !withoutZoomModal;
    const imgRef = useRef(null);
    const [playButtonShown, setPlayButtonShown] = useState(true);
    const { previewFile, srcFile, isPixel, canZoom, src, srcSet, sizes, isLargeGif } = useFullview({
        stageWidth: width !== null && width !== void 0 ? width : 0,
        stageHeight: height !== null && height !== void 0 ? height : 0,
        source,
        allowFullviewSrcsetForPngs
    });
    const handleClick = useCallback((e)=>{
        if (isLargeGif && imgRef.current && playButtonShown) {
            imgRef.current.srcset = ''; // force the src to show
            setPlayButtonShown(false);
            return;
        }
        if (canZoom && onEnterZoomMode) {
            // This is for INP purposes
            yieldToMain(()=>{
                onEnterZoomMode(source);
            });
        }
    }, [
        isLargeGif,
        playButtonShown,
        canZoom,
        onEnterZoomMode,
        source
    ]);
    const handleCloseZoom = useCallback(()=>{
        onExitZoomMode && onExitZoomMode(source);
    }, [
        onExitZoomMode,
        source
    ]);
    // todo: all this state might be simplified down to just checking .complete
    // allows you to switch sources while 1) dimming out an image that's still loading
    // and 2) only updating the img dimensions until after the image has loaded
    const [imgSize, setImgSize] = useState(()=>previewFile ? scaleToSize(previewFile, {
            width,
            height
        }) : undefined);
    const { isLoading, onSrcLoadFinish } = useImgIsLoading(imgRef, previewFile === null || previewFile === void 0 ? void 0 : previewFile.src);
    // if not loading, check for dimension changes and update size
    useEffect(()=>{
        var // on ios safari, this useEffect won't fire in certain cases when only checking
        // isLoading - so we check complete here instead (but still run the effect when
        // isLoading changes)
        _imgRef_current;
        previewFile && ((_imgRef_current = imgRef.current) === null || _imgRef_current === void 0 ? void 0 : _imgRef_current.complete) && setImgSize(scaleToSize(previewFile, {
            width,
            height
        }));
    }, [
        previewFile,
        (_imgRef_current = imgRef.current) === null || _imgRef_current === void 0 ? void 0 : _imgRef_current.complete,
        isLoading,
        width,
        height
    ]);
    if (!previewFile || !srcFile) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        className: classnames(s['root'], className),
        style: dontExpandWrapper ? undefined : {
            width,
            height
        }
    }, wrapperProps), withZoomModal && isZoomed && srcFile && /*#__PURE__*/ React.createElement(ZoomModal, {
        src: srcFile.src,
        // note: still uses this deprecated version
        srcSet: getSrcSet(source),
        width: srcFile.width,
        height: srcFile.height,
        isPixel: !!isPixel,
        onClose: handleCloseZoom
    }), isLargeGif && playButtonShown && /*#__PURE__*/ React.createElement("div", {
        className: s['gif-player'],
        style: imgSize
    }, /*#__PURE__*/ React.createElement(IconButton, {
        icon: AddVideoIcon,
        size: "large",
        onClick: handleClick
    }, "Play Gif"), /*#__PURE__*/ React.createElement("div", null, "Play large GIF (", numeral(srcFile.filesize).format('0.00b'), ")")), /*#__PURE__*/ React.createElement("img", _object_spread({
        ref: imgRef,
        alt: altText,
        className: classnames(s['image'], isPixel && s['pixel'], canZoom && s['zoomable'], canZoom && isZoomed && s['zoomed'], isLoading && s['loading']),
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        style: imgSize,
        onClick: handleClick,
        onLoad: onSrcLoadFinish,
        onError: onSrcLoadFinish
    }, imageProps)), afterImage);
};
Image.displayName = 'Image';
export default Image;

//# sourceMappingURL=Image.js.map